import { UserSwitchOutlined } from '@ant-design/icons/lib'
import { Button } from 'antd'
import React, { useContext, useState } from 'react'
import { MeContext } from '../../../api'
import { SupplierCloakDialog } from './SupplierCloakDialog'

/**
 * #7806 — the page-level "Cloak into Supplier" control, mounted into the users page's header action
 * area beside Invite User and Rebuild QS Permissions.
 *
 * SELF-GATING on `me.isAdmin`, the same predicate the row-menu cloak item uses. Three acceptance
 * criteria follow from that ONE predicate rather than from extra code:
 *  - a POWER USER who is not an admin sees nothing (the users page admits power users);
 *  - a CLOAKED admin sees nothing, because a cloaked context carries `isAdmin === false` — for a
 *    hospital cloak and a supplier cloak alike. That is the "uncloak first" rule, for free.
 *
 * ⚠️ Every hook runs ABOVE the `null` return (react-conventions §28.1): a hook below it would break
 * only in the admin case and `tsc` would stay silent.
 */
export const SupplierCloakControl: React.FC = () => {
  const { data } = useContext(MeContext)
  const [open, setOpen] = useState(false)

  const isAdmin = data?.me.isAdmin === true
  if (!isAdmin) {
    return null
  }

  return (
    <>
      <Button icon={<UserSwitchOutlined />} disabled={open} onClick={() => setOpen(true)}>
        Cloak into Supplier
      </Button>
      <SupplierCloakDialog open={open} onClose={() => setOpen(false)} />
    </>
  )
}
